/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminLoanCalculateInstallmentRequest } from '../models/AdminLoanCalculateInstallmentRequest';
import type { AdminShopUpdateRequest } from '../models/AdminShopUpdateRequest';
import type { Financier } from '../models/Financier';
import type { FinancierUserInvitationOwnerRequest } from '../models/FinancierUserInvitationOwnerRequest';
import type { FinancierUserResponse } from '../models/FinancierUserResponse';
import type { LoanSearchRequest } from '../models/LoanSearchRequest';
import type { MasterDeviceDto } from '../models/MasterDeviceDto';
import type { PaginatedFinancierSearchDto } from '../models/PaginatedFinancierSearchDto';
import type { PaginatedInstallmentPlanDto } from '../models/PaginatedInstallmentPlanDto';
import type { PaginatedMasterDeviceModelDto } from '../models/PaginatedMasterDeviceModelDto';
import type { PaginatedShop } from '../models/PaginatedShop';
import type { PaginatedUser } from '../models/PaginatedUser';
import type { Shop } from '../models/Shop';
import type { ShopDto } from '../models/ShopDto';
import type { ShopFeature } from '../models/ShopFeature';
import type { ShopSearchRequest } from '../models/ShopSearchRequest';
import type { User } from '../models/User';
import type { UserSearchRequest } from '../models/UserSearchRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AdminService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns any OK
     * @throws ApiError
     */
    public updateMasterDevice({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: MasterDeviceDto,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/admin/v2/master/devices/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public deleteMasterDevice({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/admin/v2/master/devices/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns PaginatedUser OK
     * @throws ApiError
     */
    public searchUsers({
        requestBody,
    }: {
        requestBody: UserSearchRequest,
    }): CancelablePromise<PaginatedUser> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/v2/users/search',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ShopFeature OK
     * @throws ApiError
     */
    public enableShopFeatureSlipVerify({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<ShopFeature> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/v2/shops/{shopId}/enable-slip-verify',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ShopFeature OK
     * @throws ApiError
     */
    public enableShopFeaturePos({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<ShopFeature> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/v2/shops/{shopId}/enable-pos',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ShopFeature OK
     * @throws ApiError
     */
    public enableShopFeaturePawning({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<ShopFeature> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/v2/shops/{shopId}/enable-pawning',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ShopFeature OK
     * @throws ApiError
     */
    public enableShopFeaturePawningBillContract({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<ShopFeature> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/v2/shops/{shopId}/enable-pawning-bill-contract',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ShopFeature OK
     * @throws ApiError
     */
    public enableShopFeatureLineOa({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<ShopFeature> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/v2/shops/{shopId}/enable-line-oa',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ShopFeature OK
     * @throws ApiError
     */
    public enableShopFeatureLineBot({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<ShopFeature> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/v2/shops/{shopId}/enable-line-bot',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ShopFeature OK
     * @throws ApiError
     */
    public enableShopFeatureInstallmentSaleContract({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<ShopFeature> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/v2/shops/{shopId}/enable-installment-sale-contract',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ShopFeature OK
     * @throws ApiError
     */
    public enableShopFeatureDownSaving({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<ShopFeature> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/v2/shops/{shopId}/enable-down-saving',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ShopFeature OK
     * @throws ApiError
     */
    public disableShopFeatureSlipVerify({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<ShopFeature> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/v2/shops/{shopId}/disable-slip-verify',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ShopFeature OK
     * @throws ApiError
     */
    public disableShopFeaturePos({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<ShopFeature> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/v2/shops/{shopId}/disable-pos',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ShopFeature OK
     * @throws ApiError
     */
    public disableShopFeaturePawning({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<ShopFeature> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/v2/shops/{shopId}/disable-pawning',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ShopFeature OK
     * @throws ApiError
     */
    public disableShopFeaturePawningBillContract({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<ShopFeature> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/v2/shops/{shopId}/disable-pawning-bill-contract',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ShopFeature OK
     * @throws ApiError
     */
    public disableShopFeatureLineOa({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<ShopFeature> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/v2/shops/{shopId}/disable-line-oa',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ShopFeature OK
     * @throws ApiError
     */
    public disableShopFeatureLineBot({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<ShopFeature> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/v2/shops/{shopId}/disable-line-bot',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ShopFeature OK
     * @throws ApiError
     */
    public disableShopFeatureInstallmentSaleContract({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<ShopFeature> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/v2/shops/{shopId}/disable-installment-sale-contract',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ShopFeature OK
     * @throws ApiError
     */
    public disableShopFeatureDownSaving({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<ShopFeature> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/v2/shops/{shopId}/disable-down-saving',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns PaginatedShop OK
     * @throws ApiError
     */
    public getShops({
        requestBody,
    }: {
        requestBody: ShopSearchRequest,
    }): CancelablePromise<PaginatedShop> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/v2/shops/search',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns PaginatedMasterDeviceModelDto OK
     * @throws ApiError
     */
    public getMasterDevices({
        limit,
        page,
        model,
        brand,
    }: {
        limit: number,
        page: number,
        model?: string,
        brand?: string,
    }): CancelablePromise<PaginatedMasterDeviceModelDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/v2/master/devices',
            query: {
                'model': model,
                'brand': brand,
                'limit': limit,
                'page': page,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public createMasterDevice({
        requestBody,
    }: {
        requestBody: MasterDeviceDto,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/v2/master/devices',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns PaginatedInstallmentPlanDto OK
     * @throws ApiError
     */
    public searchLoans1({
        requestBody,
    }: {
        requestBody: LoanSearchRequest,
    }): CancelablePromise<PaginatedInstallmentPlanDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/v2/loans/search',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public calculateLoanInstallment({
        requestBody,
    }: {
        requestBody: AdminLoanCalculateInstallmentRequest,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/v2/loans/calculate-installment',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns Financier OK
     * @throws ApiError
     */
    public enableFinancierLineOa({
        financierId,
    }: {
        financierId: string,
    }): CancelablePromise<Financier> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/v2/financiers/{financierId}/enable-line-oa',
            path: {
                'financierId': financierId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns Financier OK
     * @throws ApiError
     */
    public disableFinancierLineOa({
        financierId,
    }: {
        financierId: string,
    }): CancelablePromise<Financier> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/v2/financiers/{financierId}/disable-line-oa',
            path: {
                'financierId': financierId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns FinancierUserResponse OK
     * @throws ApiError
     */
    public createFinancierUserInvitation1({
        requestBody,
    }: {
        requestBody: FinancierUserInvitationOwnerRequest,
    }): CancelablePromise<FinancierUserResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/v2/financier/invitation',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns Shop OK
     * @throws ApiError
     */
    public updateShop2({
        requestBody,
    }: {
        requestBody: AdminShopUpdateRequest,
    }): CancelablePromise<Shop> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/admin/v2/shops',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns User OK
     * @throws ApiError
     */
    public getProfile(): CancelablePromise<User> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/v2/users/me',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ShopDto OK
     * @throws ApiError
     */
    public getShopById1({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<ShopDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/v2/shops/{shopId}',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns PaginatedFinancierSearchDto OK
     * @throws ApiError
     */
    public searchFinancier({
        search,
        sortBy = 'createdAt',
        sort = 'desc',
        page,
        limit = 10,
    }: {
        search?: string,
        sortBy?: string,
        sort?: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<PaginatedFinancierSearchDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/v2/financiers/search',
            query: {
                'search': search,
                'sortBy': sortBy,
                'sort': sort,
                'page': page,
                'limit': limit,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
